import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=68201a4c&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=68201a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68201a4c",
  null
  
)

export default component.exports